import { Button, Headline, Input, Text } from 'forly-kit';
import React from 'react';
import styles from './registerForm.module.scss';
import { colors } from 'forly-kit/dist/colors';
import { IActionForm } from '../form.types';
import { IRegisterFormValues } from './registerForm.types';
import { useForm, useFormState } from 'react-hook-form';
import { emailPattern } from 'src/helpers/patterns';
import { useTranslation } from 'react-i18next';

const Form: React.FC<IActionForm<IRegisterFormValues>> = ({
	action,
	isPending
}) => {
	const {t, i18n} = useTranslation();
    
	const {
		register,
		formState: { errors },
		handleSubmit,
		control,
	} = useForm<IRegisterFormValues>({
		mode: 'onChange',
	});

	const { dirtyFields, isValidating, touchedFields } = useFormState({
		control,
	});

	const getFieldStatus = (name: keyof IRegisterFormValues) => {
		if (!dirtyFields[name] && !touchedFields[name]) {
			return null;
		}

		if (errors[name]) {
			return 'error';
		} else {
			return 'success';
		}
	};

	const emailStatus = React.useMemo<'error' | 'success' | null>(() => {
		return getFieldStatus('email');
	}, [isValidating]);


	return <form className={styles.form} onSubmit={handleSubmit(action)}>
		<header className={styles.header}>
			<Headline type='h0' color={colors.neutral800}>
				{t('registeration')}
			</Headline>
			<Text size='m' className={styles.subtitle}>
				{t('registerYet')}
				<a 
					className={styles.link} 
					href={`${CONFIG.lkUrl}/${i18n.language}/login`}
				> {t('signIn')}</a>
			</Text>
		</header>
		<div>
			<Input 
				label="Email"
				register={() =>
					register('email', {
						required: {
							value: true,
							message: t('errors.requiredField'),
						},
						pattern: {
							value: emailPattern,
							message: t('errors.invalidFieldPatternEmail'),
						},
					})
				}
				status={emailStatus}
			/>
			<Text size='s'>
				{t('Iconfirm')}
				<a 
					className={styles.link}
					href={`${CONFIG.privacyLink}${i18n.language}.pdf`}
					target='_blank' 
					rel="noreferrer"
				> 
					{' ' + t('withPrivacy')}
				</a>, {t('giveAgree')} 
				<a 
					className={styles.link}
					href={`${CONFIG.userAgreementLink}${i18n.language}.pdf`}
					target='_blank' 
					rel="noreferrer"
				> 
					{' ' + t('personalData')}
				</a>
			</Text>
		</div>
		<Button 
			disabled={!!errors.email || isPending}
			variant='primary'
			text={t('register')}
			fill
		/>
	</form>;
};

export const RegisterForm = React.memo(Form);